export default __webpack_public_path__ + "static/media/logo-full-v3.2e1cbb60.svg";